angular.module('ecrd').controller('EntityFieldNotesInfoController', [
    '$scope',
    'EntityNotesVisibilityService',
    'RecordQueriesService',
    'StudyContext',
    'CrfService',
    '$stateParams',
    function($scope, EntityNotesVisibilityService, RecordQueriesService, StudyContext, CrfService, $stateParams) {
        var vm = this;
        // Bindings:
        //  - vm.fieldId
        //  - vm.onToggle()

        vm.areNotesVisible = false;

        vm.permission = {
            read: StudyContext.canWithQueries('read'),
        };
        var listIndices = CrfService.getListIndices($stateParams);

        vm.$onInit = function() {
            // vm.info = RecordQueriesService.getFieldMetaInfo(vm.fieldId, listIndices);
            vm.info = RecordQueriesService.getMetaInfo();
            vm.fieldKey = RecordQueriesService.getFieldKey(vm.fieldId, listIndices);

            vm.watcher = $scope.$watch('$ctrl.info[$ctrl.fieldKey].total', function(newValue, oldValue) {
                $scope.$emit('iconQueriesUpdated', !!newValue);
            });
        };

        vm.$onDestroy = function() {
            vm.watcher && vm.watcher();
        };

        // Show/hide details of field notes
        vm.toggleNotes = function() {
            var currentVisibility = EntityNotesVisibilityService.areNotesVisible(vm.fieldId);
            vm.areNotesVisible = !currentVisibility;

            EntityNotesVisibilityService.setFieldNotesVisibility(vm.fieldId, vm.areNotesVisible);

            vm.onToggle({
                field: vm.fieldId,
                visible: vm.areNotesVisible,
            });
        };
    }]);
